<section class="create-new-lesson">
  <div class="preloader-wrapper" *ngIf="!isLoaded">
    <mat-progress-spinner
        class="spinner"
        mode="indeterminate">
    </mat-progress-spinner>
  </div>

  <div class="create-lesson" *ngIf="isLoaded">
    <form
      (ngSubmit)="onSubmit()"
      [formGroup]="createNewLessonForm"
      (keydown.enter)="$event.preventDefault()">
      <div class="form-group">
        <div class="create-lesson__form-line">
          <div class="create-lesson__teacher-class">
            <label>
              <select
                class="form-control"
                formControlName="teacherClasses"
                (change)="changeClass()">
                <option *ngFor="let studentClass of schoolAndClass;" [value]="studentClass.class_id">
                  Шк. {{ studentClass.school_title }} | {{ studentClass.class_title }}
                </option>
              </select>
            </label>
          </div>
          <div class="create-lesson__subjects">
            <label>
              <select class="form-control" formControlName="subjects">
                <option *ngFor="let subject of subjects;" [value]="subject.id">
                  {{ subject.title }}
                </option>
              </select>
            </label>
          </div>
          <div class="create-lesson__epochs">
            <label>
              <select class="form-control" formControlName="epochs" (change)="changeEpoch($event.target.value)">
                <option *ngFor="let epoch of epochs;" [value]="epoch.id">
                  {{ epoch.title }}
                </option>
              </select>
            </label>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="create-lesson__form-line">
          <div class="create-lesson__exercises">
            <label class="pr-2" for="lessonNumber">Занятие №</label>
            <select
              class="form-control"
              formControlName="lessonNumber"
              id="lessonNumber">
              <option *ngFor="let lessonNumber of availableLessonNumbers;" [value]="lessonNumber">
                {{ lessonNumber }}
              </option>
            </select>
          </div>
          <div class="create-lesson__date">
            <label class="pr-2" for="lessonDate">Дата | Время:</label>
            <input class="form-control" id="lessonDate" type="datetime-local" name="date" formControlName="date">
          </div>
          <div class="create-lesson__online">
            <mat-checkbox color="primary" [checked]="lessonForOnline" (change)="handleLessonOnline()">Онлайн</mat-checkbox>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="create-lesson__form-line create-lesson__info">
          <div class="create-lesson__lessonName">
            <input
              type="text"
              formControlName="lessonName"
              class="form-control"
              placeholder="Введите название занятия">
          </div>
          <div class="create-lesson__lessonDescription">
            <input
              type="text"
              formControlName="lessonDescription"
              placeholder="Введите описание занятия (необяз.)"
              class="create-lesson__lessonDescription__input">
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="create-lesson__extra-settings">
          <div class="create-lesson__extra-settings__reward_options-cash"
            (click)="paymentForTaskWithCash = !paymentForTaskWithCash">
            <app-svg-icon [src]="armIcon"
              class="svg-icon rotate" [class.active]="paymentForTaskWithCash">
            </app-svg-icon>
            <span class="create-lesson__extra-settings__item__title" [class.active]="paymentForTaskWithCash">
              Оплата варианта <br> наличными
            </span>
          </div>
          <div class="create-lesson__extra-settings__reward_cash"
            (click)="rewardWithCash = !rewardWithCash">
            <app-svg-icon
              [src]="armIcon"
              class="svg-icon"
              [class.active]="rewardWithCash">
            </app-svg-icon>
            <span class="create-lesson__extra-settings__item__title" [class.active]="rewardWithCash">
              Вознаграждение наличными <br> при работе с планшетами
            </span>
          </div>
          <div class="create-lesson__extra-settings__kairos-bonus"
            (click)="hasKairosBonus = !hasKairosBonus">
            <span class="create-lesson__extra-settings__item__wrap" [class.active]="hasKairosBonus">
              <span>
                <img class="create-lesson__extra-settings__kairos-bonus__icon" [class.active]="hasKairosBonus"
                  src="/assets/images/privilege_icons/kairos_bonus_one_icon.png" alt="Кайрос бонус">
              </span>
            </span>
            <span class="create-lesson__extra-settings__item__title" [class.active]="hasKairosBonus">
              Кайрос бонус
            </span>
          </div>
          <div class="create-lesson__extra-settings__habirint"
            (click)="isHabirint = !isHabirint">
            <span class="create-lesson__extra-settings__item__wrap" [class.active]="isHabirint">
              <span>
                <img class="create-lesson__extra-settings__habirint__icon" [class.active]="isHabirint"
                  src="/assets/images/habirint.svg" alt="Хабиринт">
              </span>
            </span>
            <span class="create-lesson__extra-settings__item__title" [class.active]="isHabirint">Хабиринт</span>
          </div>
        </div>
      </div>

      <div class="create-lesson__form-line">
        <div class="ex-settings">
          <div
            class="ex-settings__collapse"
            (click)="isPrivilegesOpen = !isPrivilegesOpen"
            [attr.aria-expanded]="isPrivilegesOpen">
            <span class="label">Привилегии</span>
            <span class="arrow" [ngClass]="{active: isPrivilegesOpen}">
              <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
            </span>
          </div>
          <div [collapse]="!isPrivilegesOpen" class="ex-settings__form">
            <div formArrayName="privileges">
              <div
                class="row ex-settings__form__wrapper"
                *ngFor="let privilegeControl of getPrivilegeControls(); let i = index"
                [formGroupName]="i">
                <div class="col">
                  <div class="ex-settings__form__control">
                    <div class="row align-items-center">
                      <div class="icon">
                        <label for="character-{{i}}" class="icon__label">
                          <img
                            *ngIf="getCharacter(privilegeControl.value.character)"
                            [src]="getCharacter(privilegeControl.value.character).icon_url">
                        </label>
                      </div>
                      <select
                        formControlName="character"
                        class="select select_character"
                        id="character-{{i}}"
                        (change)="activateCharacter(i, privilegeControl)">
                        <option
                          *ngFor="let character of characters"
                          [value]="character.id">{{character.title}}</option>
                      </select>
                      <label for="privilege-{{i}}" aria-hidden="true"></label>
                      <select
                        formControlName="privilege"
                        class="select select_privilege"
                        id="privilege-{{i}}">
                        <option
                          *ngFor="let privilege of privileges"
                          [value]="privilege.id">
                          {{privilege.title | shorten: 35}}
                        </option>
                      </select>
                      <label for="applyToAll-{{i}}" class="checkbox__label">
                        <app-svg-icon
                          class="checkbox applyToAll"
                          title="Применить ко всем"
                          [src]="privilegeControl.value.applyToAll ? checkboxCheckedIcon : checkboxUncheckedIcon">
                        </app-svg-icon>
                      </label>
                      <input
                        formControlName="applyToAll"
                        id="applyToAll-{{i}}"
                        type="checkbox"
                        hidden>
                      <div (click)="onRemovePrivilege(i)" class="remove-privilege">
                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="add-privilege" (click)="onAddPrivilege()" *ngIf="canAddPrivilege()">Добавить</div>
          </div>
        </div>
      </div>
      <div class="create-lesson__form-line">
        <div class="ex-settings ex-exercise">
          <div
            class="ex-settings__collapse"
            (click)="isExExercisesOpen = !isExExercisesOpen"
            [attr.aria-expanded]="isExExercisesOpen">
            <span class="label">Доп. Задание</span>
            <span class="arrow" [ngClass]="{active: isExExercisesOpen}">
              <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
            </span>
          </div>
          <div [class.active]="isExExercisesOpen" class="ex-exercise__form" formGroupName="exExerciseObject">
            <div class="ex-exercise__title">
              <label for="extraExerciseTile" aria-hidden="true"></label>
              <select
                id="extraExerciseTile"
                formControlName="exExerciseTile"
                (change)="changeExExercise()">
                <option [value]="null">
                  ----------------------
                </option>
                <option *ngFor="let ex of exExercises" [value]="ex.id">
                  {{ ex?.title }}
                </option>
              </select>
            </div>
            <div class="ex-exercise__description" *ngIf="exExercise?.id">
              <span class="ex-exercise__description_icon">
                <i class="fa fa-exclamation" aria-hidden="true"></i>
              </span>
              <span>
                <label for="extraExerciseDescription" aria-hidden="true"></label>
                <textarea
                  id="extraExerciseDescription"
                  (keyup)="textAreaAdjust($event)"
                  formControlName="exExerciseDescription">
                </textarea>
              </span>
            </div>
            <div class="ex-exercise__reward">
              <span class="ex-exercise__reward_title">Вознаграждение: </span>
              <!-- <span class="ex-exercise__reward_add" *ngIf="exExercise?.id">
                <button type="button" (click)="addExExerciseReward()">+</button>
              </span> -->
              <span class="ex-exercise__reward_number" *ngIf="exExercise?.id">
                <label for="extraExerciseReward" aria-hidden="true"></label>
                <input
                  id="extraExerciseReward"
                  class="ex-exercise__reward_number_input"
                  type="text"
                  formControlName="exExerciseReward">
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="create-lesson__form-line ">
        <div class="ex-settings smart-sprint">
          <div
            class="ex-settings__collapse"
            (click)="isSmartSprintOpen = !isSmartSprintOpen"
            [attr.aria-expanded]="isSmartSprintOpen">
            <span class="label">Смартспринт</span>
            <span class="arrow" [ngClass]="{active: isSmartSprintOpen}">
              <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
            </span>
          </div>
          <div [collapse]="!isSmartSprintOpen" class="ex-settings__form">
            <div formArrayName="smartSprint">
              <div class="smart-sprint__title">
                <span>Длительноть</span>
                <span>Вознаграждение</span>
              </div>
              <div
                class="row ex-settings__form__wrapper"
                *ngFor="let smartSprintControl of getSmartSprintControls(); let i = index"
                [formGroupName]="i">
                <div class="col">
                  <div class="ex-settings__form__control">
                    <div class="smart-sprint__item">
                      <span class="smart-sprint__item_number">{{ i + 1 }}. </span>
                      <div class="smart-sprint__form" [class.active]="smartSprintControl.value.reward || smartSprintControl.value.duration">
                        <span>
                          <input class="smart-sprint__item_input" type="number" formControlName="duration">
                          <br>
                          <label class="smart-sprint__item_description">в секундах</label>
                        </span>
                        <span><small><font color="#9abae6">---></font></small></span>
                        <span>
                          <input class="smart-sprint__item_input" type="number" formControlName="reward">
                          <br>
                          <label class="smart-sprint__item_description">{{ declensionOfNumerals(smartSprintControl.value.reward, currentCurrency) }}</label>
                        </span>
                      </div>
                      <div (click)="onRemoveSmartSprint(i)" class="remove-privilege">
                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="add-privilege" (click)="onAddSmartSprint()">Добавить</div>
          </div>
        </div>
      </div>
      <div class="text-center">
        <div class="button-container d-flex justify-content-center">
          <button mat-raised-button type="button" class="btn btn-cancel" (click)="onCancel()">
            Отмена
          </button>
          <button mat-raised-button type="submit" class="btn btn-confirm"
            [disabled]="createNewLessonForm.invalid || !isAccessSave">
            <span *ngIf="isEditRoute">Сохранить</span>
            <span *ngIf="!isEditRoute">Создать</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</section>


<!-- модалка говорит о том что у учителя нет классов -->
<ng-template #nonClassesMsg>
  <mat-dialog-content class="error-msg__dialog">
   <p>Вы не можете создать урок так как у вас нет классов, для которых <br>
    будут созданны уроки</p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button (click)="closeDialog()">Хорошо</button>
  </mat-dialog-actions>
</ng-template>